import { CircleCheck, Lock } from 'lucide-react';

const SecureTransaction: React.FunctionComponent = function () {
  return (
    <div className="flex flex-col py-3 sm:py-6 md:py-8 border-t border-b border-neutral-300">
      <div className="flex flex-col sm:flex-row items-center justify-center text-center gap-x-8 gap-y-2">
        <div className="flex items-center gap-2">
          <div className="flex rounded-full w-8 h-8 min-w-8 min-h-8 bg-purple-50">
            <Lock className="m-auto stroke-purple-400" size={16} />
          </div>
          <p className="text-neutral-700 text-13-18">Secure Payment</p>
        </div>
        <div className="flex items-center gap-2">
          <div className="flex rounded-full w-8 h-8 min-w-8 min-h-8 bg-purple-50">
            <CircleCheck className="m-auto stroke-purple-400" size={16} />
          </div>
          <p className="text-neutral-700 text-13-18">Protected transaction</p>
        </div>
      </div>
    </div>
  );
};

export default SecureTransaction;
